import { FaSchool, FaUserGraduate, FaUsers, FaUserTie } from "react-icons/fa";

//images
import school1 from "../assets/schoolLogos/school1.jpeg";
import school2 from "../assets/schoolLogos/school2.jpeg";
import school3 from "../assets/schoolLogos/school3.jpeg";
import school4 from "../assets/schoolLogos/school4.jpeg";
import school5 from "../assets/schoolLogos/school5.jpeg";
import school6 from "../assets/schoolLogos/school6.png";

//avatars
import user1 from "../assets/avatars/user1.jpeg";
import user2 from "../assets/avatars/user2.jpeg";
import user3 from "../assets/avatars/user2.jpeg";
import user4 from "../assets/avatars/user4.jpeg";
import user5 from "../assets/avatars/user5.jpeg";
import user6 from "../assets/avatars/user6.jpeg";
import user7 from "../assets/avatars/user7.jpeg";
import user8 from "../assets/avatars/user8.jpeg";
import user9 from "../assets/avatars/user9.jpeg";

export const statBoxData = [
  {
    id: 1,
    bgColor: "#f27c1b",
    title: "Schools",
    entry: "3,000",
    icon: <FaSchool className="stat_card_icon" />,
  },
  {
    id: 2,
    bgColor: "#98c38b",
    title: "Students",
    entry: "1,500,000",
    icon: <FaUserGraduate className="stat_card_icon" />,
  },
  {
    id: 3,
    bgColor: "#633ccd",
    title: "Staff",
    entry: "50,000",
    icon: <FaUserTie className="stat_card_icon" />,
  },
  {
    id: 4,
    bgColor: "#e65061",
    title: "Parents",
    entry: "1,150,300",
    icon: <FaUsers className="stat_card_icon" />,
  },
];

export const schoolsData = [
  {
    id: 1,
    img: school1,
    title: "De'Eagles Pride Academy",
    subtitle: 2000,
  },
  {
    id: 2,
    img: school2,
    title: "Frank Gothic College",
    subtitle: 1743,
  },
  {
    id: 3,
    img: school3,
    title: "Christian Salvation Academy",
    subtitle: 1493,
  },
  {
    id: 4,
    img: school4,
    title: "Abba and Kings Academy",
    subtitle: 1200,
  },
  {
    id: 5,
    img: school5,
    title: "Gilford Model Schools",
    subtitle: 1198,
  },
  {
    id: 6,
    img: school6,
    title: "New World Model Schools",
    subtitle: 900,
  },
];

export const BarchartData = [
  {
    id: 1,
    title: "De'Eagles Pride Academy",
    code: "DEPA",
    students: 1000,
  },
  {
    id: 2,
    title: "Frank Gothic College",
    code: "FGC",
    students: 1743,
  },
  {
    id: 3,
    title: "Christian Salvation Academy",
    code: "CSA",
    students: 898,
  },
  {
    id: 4,
    title: "Divin Step Model Schools",
    code: "DSMS",
    students: 1500,
  },
  {
    id: 5,
    title: "Gilford Model Schools",
    code: "GMS",
    students: 1203,
  },
  {
    id: 6,
    title: "New World Model Schools",
    code: "NWMS",
    students: 900,
  },
  {
    id: 7,
    title: "De'Eagles Pride Academy",
    code: "DEPA",
    students: 1200,
  },
  {
    id: 8,
    title: "Frank Gothic College",
    code: "FGC",
    students: 800,
  },
  {
    id: 9,
    title: "Christian Salvation Academy",
    code: "CSA",
    students: 1300,
  },
  {
    id: 10,
    title: "Divin Step Model Schools",
    code: "DSMS",
    students: 144,
  },
  {
    id: 11,
    title: "Gilford Model Schools",
    code: "GMS",
    students: 762,
  },
  {
    id: 12,
    title: "New World Model Schools",
    code: "NWMS",
    students: 765,
  },
  {
    id: 13,
    title: "New World Model Schools",
    code: "NWMS",
    students: 935,
  },
  {
    id: 14,
    title: "Divin Step Model Schools",
    code: "DSMS",
    students: 1534,
  },
];

export const ActivityData = [
  {
    id: 1,
    title: "De'Eagles Pride Academy",
    subtitle: "Added a student",
    date: "2nd March",
    time: "09:32",
    color: "#389d17",
  },
  {
    id: 2,
    title: "Divin Step Model Schools",
    subtitle: "Added a staff",
    date: "2nd March",
    time: "09:32",
    color: "#389d17",
  },
  {
    id: 3,
    title: "New World Model Schools",
    subtitle: "Added a parent",
    date: "2nd March",
    time: "09:32",
    color: "#389d17",
  },
  {
    id: 4,
    title: "De'Eagles Pride Academy",
    subtitle: "Disabled a student",
    date: "2nd March",
    time: "09:32",
    color: "#e65061",
  },
  {
    id: 5,
    title: "De'Eagles Pride Academy",
    subtitle: "Disable a staff",
    date: "2nd March",
    time: "09:32",
    color: "#e65061",
  },
];

export const CustomerService = [
  /* CustomerService */
  {
    id: 1000,
    name: "James Butt",
    country: {
      name: "Algeria",
      code: "dz",
    },
    company: "Benton, John B Jr",
    date: "2015-09-13",
    status: "unqualified",
    verified: true,
    activity: 17,
    representative: {
      name: "Ioni Bowcher",
      image: user1,
    },
    balance: 70663,
  },
  {
    id: 1001,
    name: "Ada George",
    country: {
      name: "Algeria",
      code: "dz",
    },
    company: "Benton, John B Jr",
    date: "2015-09-13",
    status: "unqualified",
    verified: true,
    activity: 17,
    representative: {
      name: "Ioni Bowcher",
      image: user2,
    },
    balance: 70663,
  },
  {
    id: 1002,
    name: "James Butt",
    country: {
      name: "Algeria",
      code: "dz",
    },
    company: "Benton, John B Jr",
    date: "2015-09-13",
    status: "unqualified",
    verified: true,
    activity: 17,
    representative: {
      name: "Ioni Bowcher",
      image: user3,
    },
    balance: 70663,
  },
  {
    id: 1003,
    name: "James Butt",
    country: {
      name: "Algeria",
      code: "dz",
    },
    company: "Benton, John B Jr",
    date: "2015-09-13",
    status: "unqualified",
    verified: true,
    activity: 17,
    representative: {
      name: "Ioni Bowcher",
      image: "ionibowcher.png",
    },
    balance: 70663,
  },
  {
    id: 1004,
    name: "James Butt",
    country: {
      name: "Algeria",
      code: "dz",
    },
    company: "Benton, John B Jr",
    date: "2015-09-13",
    status: "unqualified",
    verified: true,
    activity: 17,
    representative: {
      name: "Ioni Bowcher",
      image: user4,
    },
    balance: 70663,
  },
  {
    id: 1005,
    name: "James Butt",
    country: {
      name: "Algeria",
      code: "dz",
    },
    company: "Benton, John B Jr",
    date: "2015-09-13",
    status: "unqualified",
    verified: true,
    activity: 17,
    representative: {
      name: "Ioni Bowcher",
      image: user5,
    },
    balance: 70663,
  },
  {
    id: 1006,
    name: "James Butt",
    country: {
      name: "Algeria",
      code: "dz",
    },
    company: "Benton, John B Jr",
    date: "2015-09-13",
    status: "unqualified",
    verified: true,
    activity: 17,
    representative: {
      name: "Ioni Bowcher",
      image: user6,
    },
    balance: 70663,
  },
  {
    id: 1007,
    name: "James Butt",
    country: {
      name: "Algeria",
      code: "dz",
    },
    company: "Benton, John B Jr",
    date: "2015-09-13",
    status: "unqualified",
    verified: true,
    activity: 17,
    representative: {
      name: "Ioni Bowcher",
      image: user7,
    },
    balance: 70663,
  },
  {
    id: 1008,
    name: "James Butt",
    country: {
      name: "Algeria",
      code: "dz",
    },
    company: "Benton, John B Jr",
    date: "2015-09-13",
    status: "unqualified",
    verified: true,
    activity: 17,
    representative: {
      name: "Ioni Bowcher",
      image: user8,
    },
    balance: 70663,
  },
  {
    id: 1009,
    name: "James Butt",
    country: {
      name: "Algeria",
      code: "dz",
    },
    company: "Benton, John B Jr",
    date: "2015-09-13",
    status: "unqualified",
    verified: true,
    activity: 17,
    representative: {
      name: "Ioni Bowcher",
      image: user9,
    },
    balance: 70663,
  },
];
